import * as ARROW_DOWN from '../../svg/arrow-down.svg';
import * as DUPLICATE from '../../svg/duplicate.svg';
import * as SEARCH from '../../svg/search.svg';
import * as VIEW from '../../svg/view.svg';
import * as DOT from '../../svg/dot.svg';
import * as FLAG from '../../svg/flag.svg';
import * as PAPER_CLIP from '../../svg/paperclip.svg';
import * as USER from '../../svg/user.svg';
import * as WAIT from '../../svg/wait.svg';
import * as COPY_PASTE from '../../svg/copy-paste.svg';

export const arrowDown = ARROW_DOWN;
export const duplicate = DUPLICATE;
export const search = SEARCH;
export const view = VIEW;
export const dot = DOT;
export const flag = FLAG;
export const paperclipIcon = PAPER_CLIP;
export const user = USER;
export const wait = WAIT;
export const copy = COPY_PASTE;
